export const USDollar = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export const USDollarShort = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

export const AGING_COLORS = [
  "#1f6f8b",
  "#ee5827",
  "#8884d8",
  "#2e9e6b",
  "#c026d3",
  "#f59e0b",
  "#0ea5e9",
  "#64748b",
];

export const MONTH_OPTIONS = Array.from({ length: 12 }, (_, monthIndex) => ({
  value: monthIndex + 1,
  label: new Intl.DateTimeFormat("en-US", { month: "short" }).format(
    new Date(2020, monthIndex, 1)
  ),
}));

export const PERIOD_TYPE_OPTIONS = [
  { value: "month", label: "Specific Month" },
  { value: "year_by_month", label: "Year (month by month)" },
  { value: "year_accumulated", label: "Year Accumulated" },
];

export function toNumber(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function formatPeriodLabel(period = "") {
  if (!period) return "-";
  const [year, month] = period.split("-");
  if (!month) return year;
  return `${
    MONTH_OPTIONS.find((option) => option.value === Number(month))?.label || month
  }/${year}`;
}

export function formatDate(dateStr) {
  if (!dateStr) return "-";
  if (dateStr.includes("-")) {
    const [year, month, day] = dateStr.substring(0, 10).split("-");
    return `${month}/${day}/${year}`;
  }
  return `${dateStr.substring(4, 6)}/${dateStr.substring(
    6,
    8
  )}/${dateStr.substring(0, 4)}`;
}
